import React, { useState } from "react";
import ProfileVisibility from "./ProfileVisibility";
import CompanyInformation from "./CompanyInformation";
import SecurityInformation from "./Security";
import EmailInformation from "./Email";
import SellerFarmerFaqComp from "./Faq";

const SellerFarmerProfileModule = () => {
  const [activeTab, setActiveTab] = useState("Profile & Visibility");
  const tabs = [
    "Profile & Visibility",
    "Company Information",
    "Email",
    "Security",
    "FAQ",
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "Profile & Visibility":
        return <ProfileVisibility />;
      case "Company Information":
        return <CompanyInformation />;
      case "Security":
        return <SecurityInformation />;
      case "Email":
        return <EmailInformation />;
      case "FAQ":
        return <SellerFarmerFaqComp />;
      default:
        return <ProfileVisibility />;
    }
  };

  return (
    <div className="buyer-layout">
      <div className="amtpl-tabs">
        <div className="content3">
          <main className="main-content">
            <div className="mb-3 main-tab">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`buttonclass ${
                    activeTab === tab ? "active" : "notactive"
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="row">{renderTabContent()}</div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default SellerFarmerProfileModule;
